import ServiceBase from './ServiceBase';

// Mock style notes — body contains raw CSS, format='css', title identifies the theme.
// Replace Promise.resolve with a real agent.get call once BE endpoint exists.

const _darkCss = `
.jerny-body-content {
    font-family: 'DM Sans', sans-serif;
    font-size: 13px;
    line-height: 1.6;
}

.jerny-body-content h1 {
    font-size: 28px;
    font-weight: 700;
    color: #e0eeff;
    margin: 20px 0 8px;
    letter-spacing: -0.3px;
    border-bottom: 1px solid #294766;
    padding-bottom: 4px;
}

.jerny-body-content h2 {
    font-size: 18px;
    font-weight: 600;
    color: #a3d1ff;
    margin: 14px 0 4px;
}

.jerny-body-content h3 {
    font-size: 14px;
    font-weight: 600;
    color: #7fb3d3;
    margin: 10px 0 4px;
}

.jerny-body-content ul,
.jerny-body-content ol {
    padding-left: 20px;
    margin: 4px 0;
}

.jerny-body-content li {
    margin: 2px 0;
}

.jerny-body-content li p {
    margin: 0;
}

.jerny-body-content p {
    margin: 2px 0;
}
`.trim();

const _lightCss = `
.jerny-body-content {
    font-family: 'DM Sans', sans-serif;
    font-size: 13px;
    line-height: 1.6;
}

.jerny-body-content h1 {
    font-size: 28px;
    font-weight: 700;
    color: #1a2e42;
    margin: 20px 0 8px;
    letter-spacing: -0.3px;
    border-bottom: 1px solid #b0c8e0;
    padding-bottom: 4px;
}

.jerny-body-content h2 {
    font-size: 18px;
    font-weight: 600;
    color: #2a5a8a;
    margin: 14px 0 4px;
}

.jerny-body-content h3 {
    font-size: 14px;
    font-weight: 600;
    color: #3a6a9a;
    margin: 10px 0 4px;
}

.jerny-body-content ul,
.jerny-body-content ol {
    padding-left: 20px;
    margin: 4px 0;
}

.jerny-body-content li {
    margin: 2px 0;
}

.jerny-body-content li p {
    margin: 0;
}

.jerny-body-content p {
    margin: 2px 0;
}
`.trim();

const _mockItems = [
    { rk: 'style-mock-dark-001', title: 'BodyEditorStyle - Dark', format: 'css', body: _darkCss },
    { rk: 'style-mock-light-001', title: 'BodyEditorStyle - Light', format: 'css', body: _lightCss },
];

class StyleService extends ServiceBase {
    /**
     * Returns all style notes.
     * Mocked — replace with agent.get once BE endpoint exists.
     * @returns {Promise<{data: {items: object[]}}>}
     */
    getStyles = () => {
        return Promise.resolve({ data: { items: _mockItems } });
    };
}

const styleService = new StyleService();
export default styleService;
